// CPT-582: dashboard-mfe's first analytics surface. Names match payments-mfe's
// "Client Payment ..." family so the entry point and the flow read as one funnel
// on a board, but every name here is new: nothing this file emits changes the
// meaning of an event an existing dashboard already counts.
//
// Client Payment Method Selected, and the Initiation source property the plan
// wants stamped on it, are deliberately absent. That event lives in request-mfe
// and is read by shipped boards, so extending it is a separate, cross-repo change.
export const EVENT = {
    ParticipantPaymentEntryViewed: 'Client Payment Entry Point Viewed',
    ParticipantPaymentPurposeSheetOpened: 'Client Payment Purpose Sheet Opened',
    ParticipantPaymentPurposeSelected: 'Client Payment Purpose Selected',
    ParticipantPaymentStartFailed: 'Client Payment Start Failed',
} as const;

// Values are the strings payments-mfe already sends for the same property, so a
// board can group the entry point and the flow on one Purpose type.
export const PURPOSE_TRACKING_VALUES: Record<string, string> = {
    EMD: 'Earnest Money Deposit',
    CashToClose: 'Cash to Close',
    Other: 'Other payment',
};

export const UNKNOWN_PURPOSE_TYPE = 'Unknown';

export const INITIATION_SOURCE = 'Participant initiated';
